
export default {
  name: 'Footer',

  computed: {
    linkPrivacy: function () {
      return this.$nuxt.context?.env?.linkPrivacy;
    },
    currentYear: function () {
      return new Date().getFullYear();
    },
  },

  components: {
    Menu: () => import('~/components/footer/Menu'),
    Contacts: () => import('~/components/footer/Contacts'),
  },
};
